import Vue from "vue";
import Vuex from "vuex";
import coreStore from "./core/store";
import authStore from "./modules/auth/store";
import clientsStore from "./modules/clients/store";
import rulesStore from "./modules/riskEngine/rules/store";
import apiKeysStore from "./modules/apiKeys/store";
import rolesStore from "./modules/acl/roles/store";
import aclEntitiesStore from "./modules/acl/aclEntities/store";
import schedulerWorkersReportStore from "./modules/schedulerWorkers/report/store";
import schedulerWorkersStore from "./modules/schedulerWorkers/workers/store";
import apiCallsStore from "./modules/apiCalls/store";
import documentationStore from "./modules/documentation/store";
import dashboardStore from "./modules/dashboard/store";
import organizationsStore from "./modules/organizations/store";
import businessGroupsStore from "./modules/businessGroups/store";
import campaignsStore from "./modules/riskEngine/campaigns/store";
import productCallsStore from "./modules/productCalls/store";
import realtimeStore from "./modules/reports/realtime/store";
import logsStore from "./modules/errors/store";
import billingStore from "./modules/billing/store";
import syncStore from "./modules/sync/store";
import exportsStore from "./modules/exports/store";
import notificationsStore from "./modules/notifications/list/store";
import notificationsSettingStore from "./modules/notifications/setting/store";
import revenueReportStore from "./modules/billing/revenueReport/store";
import clickByDynamicConfigsStore from "./modules/clickByDynamicConfigs/store"
import apiLimitsStore from "./modules/apiLimits/store"
import appConfigsStore from "./modules/appConfigs/store"
import insightModelsStore from "./modules/insightModels/store"
import trendReportsStore from "./modules/trendReports/store"
import dictionariesStore from "./core/dictionaries";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: null,
  },
  mutations: {
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
  },
  actions: {},
  modules: {
    core: coreStore,
    clients: clientsStore,
    auth: authStore,
    apiKeys: apiKeysStore,
    roles: rolesStore,
    aclEntities: aclEntitiesStore,
    schedulerWorkersReport: schedulerWorkersReportStore,
    schedulerWorkers: schedulerWorkersStore,
    apiCalls: apiCallsStore,
    documentation: documentationStore,
    dashboard: dashboardStore,
    organizations: organizationsStore,
    businessGroups: businessGroupsStore,
    rules: rulesStore,
    campaigns: campaignsStore,
    productCalls: productCallsStore,
    realtime: realtimeStore,
    logs: logsStore,
    billing: billingStore,
    sync: syncStore,
    exports: exportsStore,
    notifications: notificationsStore,
    notificationsSetting: notificationsSettingStore,
    revenueReport: revenueReportStore,
    dictionaries: dictionariesStore,
    clickByDynamicConfigs: clickByDynamicConfigsStore,
    apiLimits: apiLimitsStore,
    appConfigs: appConfigsStore,
    insightModels: insightModelsStore,
    trendReports: trendReportsStore,
  },
});
